import { CheckCircle2 } from "lucide-react";
import tktiRuxsat from "./images/tcti-ruhsat.png";

export default function Institute({ institute }) {
  return (
    <section className="py-20" style={{ background: "#f8f8fb" }}>
      <div className="max-w-7xl mx-auto px-2">
        <div className="dc-inst-card">
          <div className="dc-inst-dots" />

          {/* Text */}
          <div style={{ position: "relative" }}>
            <div className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: "rgba(255,255,255,0.55)" }}>
              {institute.eyebrow}
            </div>
            <h2 className="font-extrabold text-white mb-4 leading-tight tracking-tight"
              style={{ fontSize: "clamp(20px,2.8vw,30px)" }}>
              {institute.title}
            </h2>
            <p className="text-sm leading-relaxed mb-5" style={{ color: "rgba(255,255,255,0.7)" }}>
              {institute.desc}
            </p>
            <div className="rounded-xl p-3.5"
              style={{ background: "rgba(255,255,255,0.12)", border: "1.5px solid rgba(255,255,255,0.2)" }}>
              <span className="text-sm font-semibold" style={{ color: "rgba(255,255,255,0.85)" }}>
                {institute.address}
              </span>
            </div>
          </div>

          {/* Image */}
          <div style={{ position: "relative" }}>
            <div className="dc-inst-placeholder">
              <img src={tktiRuxsat} alt={institute.imageAlt}
                style={{ width: "100%", borderRadius: 20, display: "block" }} />
            </div>
            <div className="dc-inst-floating">
              <CheckCircle2 size={20} className="text-green-500" strokeWidth={2.5} />
              <div>
                <div className="font-bold text-gray-900" style={{ fontSize: 13 }}>{institute.floatingTitle}</div>
                <div className="text-gray-400 mt-0.5" style={{ fontSize: 11 }}>{institute.floatingSub}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}